import { css } from '@emotion/react'
import styled from '@emotion/styled'

const itemStyles = ({ theme }) => css`
  label: category-carousel__item;

  display: block;
  width: 125px;
  color: ${theme.colors.n900};
`

export const Item = styled('a')(itemStyles)

const thumbSvgStyles = ({ theme, isSvg }) =>
  isSvg &&
  css`
    label: category-carousel__thumb-svg;

    background-color: ${theme.colors.b900};

    border: 1px solid ${theme.colors.n100};

    svg {
      label: thumb__icon;

      fill: ${theme.colors.white};
      height: 70px;
      width: 70px;
    }
  `

const thumbBlackWeekendStyles = ({ theme, isBlackWeekend }) =>
  isBlackWeekend &&
  css`
    label: category-carousel__thumb--black-weekend;

    background-color: ${theme.colors.n900};
  `

const thumbnailStyles = ({ theme, imageSize }) => css`
  label: category-carousel__thumb;

  border-radius: ${theme.borderRadius.giga};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${imageSize}px;
  width: ${imageSize}px;
`

export const Thumbnail = styled('img')(
  thumbnailStyles,
  thumbSvgStyles,
  thumbBlackWeekendStyles
)
